"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("@antv/util");
var base_1 = require("./components/base");
exports.ElementLabels = base_1.default;
var interval_1 = require("./components/interval");
var pie_1 = require("./components/pie");
var polar_1 = require("./components/polar");
var factory_1 = require("./components/factory");
exports.getElementLabels = factory_1.getElementLabels;
exports.registerElementLabels = factory_1.registerElementLabels;
var LabelController = /** @class */ (function () {
    function LabelController(element) {
        this.element = null;
        this.labelsContainer = null;
        this.element = element;
    }
    LabelController.prototype._createLabelsContainer = function () {
        var element = this.element;
        var elementType = element.get('type');
        var coord = element.get('coord');
        var labelOptions = element.get('labelOptions');
        var Ctor = this._getElementLabelsConstructor(labelOptions.labelType, coord.type, elementType);
        var container = element.get('frontgroundGroup');
        var scales = _.map(element.get('labelOptions').fields, function (field) { return element.createScale(field); });
        var labelsContainer = container.addGroup(Ctor, {
            labelOptions: _.mix({
                scales: scales,
            }, labelOptions),
            coord: coord,
            element: element,
            elementType: elementType,
            theme: element.get('theme'),
            visible: element.get('visible'),
        });
        this.labelsContainer = labelsContainer;
    };
    LabelController.prototype.addLabels = function (points, shapes) {
        this._createLabelsContainer();
        this.labelsContainer.showLabels(points, shapes);
        var labelsGroup = this.labelsContainer.get('labelsGroup');
        return labelsGroup.get('children'); // 返回创建的 labels
    };
    LabelController.prototype.changeVisible = function (visible) {
        this.labelsContainer && this.labelsContainer.set('visible', visible);
    };
    LabelController.prototype.clear = function () {
        var labelsContainer = this.labelsContainer;
        labelsContainer && !labelsContainer.destroyed && labelsContainer.remove();
    };
    LabelController.prototype._getElementLabelsConstructor = function (labelType, coordType, elementType) {
        var type = labelType || 'base';
        if (coordType === 'polar' && type === 'base') {
            type = 'polar';
        }
        else if (coordType === 'theta' && type === 'base') { // pie chart
            type = 'pie';
        }
        else if ((elementType === 'interval' || elementType === 'polygon') && type === 'base') { // bar
            type = 'interval';
        }
        return factory_1.getElementLabels(type);
    };
    return LabelController;
}());
exports.default = LabelController;
factory_1.registerElementLabels('base', base_1.default);
factory_1.registerElementLabels('interval', interval_1.default);
factory_1.registerElementLabels('pie', pie_1.default);
factory_1.registerElementLabels('polar', polar_1.default);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/controller/label/index.js
// module id = 595
// module chunks = 37